import { render, staticRenderFns } from "./FormTraining.vue?vue&type=template&id=be246d56&scoped=true"
import script from "./FormTraining.vue?vue&type=script&lang=js"
export * from "./FormTraining.vue?vue&type=script&lang=js"
import style0 from "./FormTraining.vue?vue&type=style&index=0&id=be246d56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be246d56",
  null
  
)

export default component.exports